//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from '../header/header.vue'
export default {
  name: 'registeSuccess',
  data() {
    return {
      second: 5 // 倒计时数字
    };
  },
  components: { Header },
  created() {
    // 倒计时
    this.fnHandleTimer()
  },
  methods: {
    fnHandleTimer() { // 倒计时
      let maxSecond = 5
      let timer = setInterval(() => {
        if (this.second > 0 && this.second <= maxSecond) {
          this.second--
        } else {
          clearInterval(timer)
          this.fnGotoUserCenterPage()
        }
       }, 1000)
    },
    fnGotoUserCenterPage() { // 手动跳转到用户重心
      this.$router.push({path: '/'})
      if(window.opener!=null){
        window.opener.location.reload()//刷新父页面
      }
      this.$nextTick(()=>{
        localStorage.setItem('alreadyLogin', 'alreadyLogin' + new Date().getTime() + '')
      })
      // 跳转到用户中心
      // this.fnGotoUserCenter({
      //   self_redirect: '1',
      //   sucessCallBack: function () {
      //     // if(window.opener!=null){
      //     //    window.opener.location.reload()//刷新父页面
      //     // }
      //   }
      // })
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/registeSuccess.vue